import HolidaysSelector from './HolidaysSelector';
import HolidaysCalendarEvent from './HolidaysCalendarEvent';
import styles from './calendar.module.css';
import useGlobalVariable from '@lib/store/hooks/useGlobalVariables';

export default function HolidaysCalendar({
  calendarItem,
  locale,
  onPrevious,
  onNext,
  hasPrevious,
  hasNext,
  position,
  total,
}) {
  const { gv } = useGlobalVariable();
  return (
    <div className={styles.calendar}>
      <HolidaysSelector
        calendarItem={calendarItem}
        onPrevious={onPrevious}
        onNext={onNext}
        hasPrevious={hasPrevious}
        hasNext={hasNext}
        position={position}
        total={total}
      />
      <div className={styles.headerRow}>
        <span className={styles.headerLabel}>{gv('tc_date', 'raw')}</span>
        <span className={styles.headerLabel}>{gv('tc_event_name', 'raw')}</span>
        <span className={styles.headerLabel}>{gv('tc_more_info', 'raw')}</span>
      </div>
      <div className={styles.eventList}>
        {calendarItem?.events?.map((event, index) => (
          <HolidaysCalendarEvent key={`${event?.date}-${index}`} eventData={event} locale={locale} />
        ))}
      </div>
    </div>
  );
}
